import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Angular Material Modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';

//Components
import { DniEntryComponent } from './components/dni-entry/dni-entry.component';
import { TravelResultComponent } from './components/travel-result/travel-result.component';
import { RecorridoComponent } from './components/recorrido.component';

//Pipes
import { MonedaPipe } from './pipes/moneda.pipe';
import { TransformDocumentType } from './pipes/transformDocumentType.pipe';
import { TitleCaseSmartPipe } from '../core/pipes/titleCaseSmart.pipe';
import { CurrencyPipe } from '@angular/common';
import { OperationTypePipe } from './pipes/operation-type.pipe';
import { OperationStatusPipe } from './pipes/operation-status.pipe';
import { TicketStatusPipe } from './pipes/ticket-status.pipe';

@NgModule({
  declarations: [
    DniEntryComponent,
    MonedaPipe,
    TransformDocumentType,
    OperationTypePipe,
    OperationStatusPipe,
    TicketStatusPipe
  ],
  providers: [CurrencyPipe],
  imports: [
    CommonModule,
    RecorridoComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatListModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatIconModule,
    MatCardModule,
    MatSnackBarModule,
    MatGridListModule,
    TitleCaseSmartPipe
  ],
  exports: [
    DniEntryComponent,
    MonedaPipe,
    TransformDocumentType,
    TitleCaseSmartPipe,
    RecorridoComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatListModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatIconModule,
    MatCardModule,
    MatSnackBarModule,
    MatGridListModule,
    OperationTypePipe,
    OperationStatusPipe,
    TicketStatusPipe
  ]
})
export class SharedModule { }
